import { Injectable } from '@angular/core';
import { CommonsSessionStorageService } from 'ib-web-commons/utils';
import { MmBAppConstants } from "@src/ib-MmB-constants";
import { MmbNewPaymentAvailableService } from './ib-new-payment-available.service';
import { PaymentViewType } from '../enums/ib-Mmb-payments-enum';

@Injectable()
export class IbMmbPaymentsPageService {
    constructor (
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private MmbNewPaymentAvailableService: MmbNewPaymentAvailableService
    ) {}

    public checkPaymentsViewType = async () :Promise<string> => {
        const type: string  = await this.callPaymentsViewTypeService();
        this.CommonsSessionStorageService.set(MmBAppConstants.STORAGE_KEYS.PAYMENTS_VIEWTYPE, type);
        return type;
    };

    private callPaymentsViewTypeService = () : Promise <string>  => {
        return this.MmbNewPaymentAvailableService.callPromised()
            .then (
                (data) => {
                    return (data.available? PaymentViewType.NEW: PaymentViewType.OLD);
                }
            ).catch(() => PaymentViewType.OLD);
    };
}
